import { render, staticRenderFns } from "./graph-node.html?vue&type=template&id=37a72889&scoped=true&"
import script from "./graph-node.js?vue&type=script&lang=js&"
export * from "./graph-node.js?vue&type=script&lang=js&"
import style0 from "./graph-node.scss?vue&type=style&index=0&id=37a72889&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a72889",
  null
  
)

export default component.exports